module.exports = __webpack_public_path__ + "static/media/surface-tension.cdce9872.mp3";